import React, { useState, useRef, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterCard from '../../components/FilterCard/FilterCard';
import Select from '../../components/Select/Select';
import html2canvas from 'html2canvas';
import styles from './Grafikler.module.css';

const Grafikler = () => {
  const [filterStatus, setFilterStatus] = useState([{ value: 'ongoing', label: 'Devam Eden' }]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const [modalSelectedYear, setModalSelectedYear] = useState([{ value: 'all', label: 'Tüm Yıllar' }]);
  const [modalSelectedFaculty, setModalSelectedFaculty] = useState([{ value: 'all', label: 'Tüm Fakülteler' }]);
  const [selectedFaculty, setSelectedFaculty] = useState([{ value: 'all', label: 'Tüm Fakülteler' }]);
  const [yearRange, setYearRange] = useState([{ value: 'last5', label: 'Son 5 Yıl' }]);
  const [displayYears, setDisplayYears] = useState([]);
  
  const statusOptions = [
    { value: 'all', label: 'Tümü' },
    { value: 'ongoing', label: 'Devam Eden' },
    { value: 'completed', label: 'Tamamlanan' },
    { value: 'planned', label: 'Planlanan' },
    { value: 'cancelled', label: 'İptal Edilen' }
  ];

  const yearRangeOptions = [
    { value: 'last5', label: 'Son 5 Yıl' },
    { value: 'last3', label: 'Son 3 Yıl' },
    { value: 'last10', label: 'Son 10 Yıl' },
    { value: 'all', label: 'Tüm Zamanlar' }
  ];

  const handleStatusChange = (selected) => {
    setFilterStatus(selected || [{ value: 'ongoing', label: 'Devam Eden' }]);
  };

  const handleYearRangeChange = (selected) => {
    if (selected && selected.length > 0) {
      setYearRange([selected[selected.length - 1]]);
    } else {
      setYearRange([{ value: 'last5', label: 'Son 5 Yıl' }]);
    }
  };

  const handleFacultyChange = (selected) => {
    setSelectedFaculty(selected || [{ value: 'all', label: 'Tüm Fakülteler' }]);
  };

  const baseOptions = {
    credits: {
      enabled: false
    }
  };

  const chartRefs = {
    yillikTrend: useRef(null),
    fakulteDagilim: useRef(null),
    butceDagilim: useRef(null),
    atifAnalizi: useRef(null),
    projeSayiButce: useRef(null),
    modalProje: useRef(null),
    modalButce: useRef(null),
    modalGenel: useRef(null)
  };

  const downloadAsPNG = (chartRef, fileName) => {
    if (chartRef.current && chartRef.current.chart) {
      const container = chartRef.current.chart.container;
      const svgElement = container.getElementsByTagName('svg')[0];
      
      html2canvas(container, {
        scale: 2,
        backgroundColor: null,
        logging: false,
        allowTaint: true,
        useCORS: true,
        onclone: function(clonedDoc) {
          const clonedSvg = clonedDoc.querySelector('svg');
          if (clonedSvg) {
            clonedSvg.style.backgroundColor = 'white';
          }
        }
      }).then(canvas => {
        const link = document.createElement('a');
        link.download = `${fileName}.png`;
        link.href = canvas.toDataURL('image/png');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(err => {
        console.error('Grafik indirme hatası:', err);
      });
    }
  };

  const fakulteler = [
    { id: 'enerji', name: 'Enerji Enstitüsü', budget: 19959997.97 },
    { id: 'avrasya', name: 'Avrasya Yer Bilimleri Enstitüsü', budget: 52508306.06 },
    { id: 'bilisim', name: 'Bilişim Enstitüsü', budget: 12604898.15 },
  ];

  const yillar = ['2024', '2023', '2022', '2021', '2020'];

  const yearOptions = [
    { value: 'all', label: 'Tüm Yıllar' },
    ...yillar.map(yil => ({
      value: yil,
      label: yil
    }))
  ];

  const facultyOptions = [
    { value: 'all', label: 'Tüm Fakülteler' },
    ...fakulteler.map(fakulte => ({
      value: fakulte.id,
      label: fakulte.name
    }))
  ];

  const handleModalYearChange = (selected) => {
    setModalSelectedYear(selected || [{ value: 'all', label: 'Tüm Yıllar' }]);
  };

  const handleModalFacultyChange = (selected) => {
    if (selected && selected.length > 0) {
      setModalSelectedFaculty([selected[selected.length - 1]]);
    } else {
      setModalSelectedFaculty([{ value: 'all', label: 'Tüm Fakülteler' }]);
    }
    if (selected && selected.length > 0) {
      const lastSelected = selected[selected.length - 1];
    }
  };

  const fakulteButceOptions = {
    ...baseOptions,
    chart: {
      type: 'column',
      height: 500
    },
    title: {
      text: 'Fakültelere Göre Bütçe Dağılımı'
    },
    xAxis: {
      categories: fakulteler.map(f => f.name),
      title: {
        text: 'Fakülteler'
      }
    },
    yAxis: {
      title: {
        text: 'Bütçe (TL)'
      },
      labels: {
        formatter: function() {
          return this.value.toLocaleString('tr-TR') + ' ₺';
        }
      }
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.x + '</b><br/>' +
               'Bütçe: ' + this.y.toLocaleString('tr-TR') + ' ₺';
      }
    },
    series: [{
      name: 'Toplam Bütçe',
      data: fakulteler.map(f => f.budget),
      color: '#4285f4'
    }]
  };

  const yillikTrendOptions = {
    ...baseOptions,
    chart: {
      type: 'area',
      height: 350
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024'],
      tickmarkPlacement: 'on'
    },
    yAxis: {
      title: {
        text: 'Sayı'
      }
    },
    plotOptions: { 
      area: {
        stacking: 'normal',
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    series: [{
      name: 'Yayınlar',
      data: [120, 140, 160, 180, 200, 220],
      color: '#4285f4'
    }, {
      name: 'Projeler',
      data: [45, 55, 65, 75, 85, 95],
      color: '#34a853'
    }]
  };

  const fakulteDagilimOptions = {
    ...baseOptions,
    chart: {
      type: 'column',
      height: 350
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['Mühendislik', 'Fen', 'Tıp', 'İşletme', 'Mimarlık']
    },
    yAxis: {
      title: {
        text: 'Sayı'
      }
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },
    series: [{
      name: 'Q1',
      data: [25, 20, 15, 10, 8],
      color: '#4285f4'
    }, {
      name: 'Q2',
      data: [20, 15, 12, 8, 6],
      color: '#34a853'
    }, {
      name: 'Diğer',
      data: [15, 10, 8, 6, 4],
      color: '#fbbc05'
    }]
  };

  const butceDagilimOptions = {
    ...baseOptions,
    chart: {
      type: 'pie',
      height: 350
    },
    title: {
      text: null
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.percentage:.1f}%'
        },
        showInLegend: true
      }
    },
    series: [{
      name: 'Bütçe',
      data: [
        { name: 'TÜSEB', y: 35, color: '#4285f4' },
        { name: 'BAP', y: 25, color: '#34a853' },
        { name: 'TÜBİTAK', y: 20, color: '#fbbc05' },
        { name: 'TTO', y: 15, color: '#ea4335' },
        { name: 'Diğer', y: 5, color: '#673ab7' }
      ]
    }]
  };

  const atifAnaliziOptions = {
    ...baseOptions,
    chart: {
      type: 'line',
      height: 350
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024']
    },
    yAxis: {
      title: {
        text: 'Atıf Sayısı'
      }
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true
        }
      }
    },
    series: [{
      name: 'Q1 Atıflar',
      data: [500, 600, 750, 900, 1100, 1300],
      color: '#4285f4'
    }, {
      name: 'Q2 Atıflar',
      data: [300, 400, 500, 600, 700, 800],
      color: '#34a853'
    }]
  };

  const projeSayiButceOptions = {
    ...baseOptions,
    chart: {
      type: 'column',
      height: 350
    },
    title: {
      text: null
    },
    xAxis: {
      categories: ['Enerji', 'Bilişim', 'Sağlık', 'Eğitim', 'Diğer']
    },
    yAxis: [{
      title: {
        text: 'Proje Sayısı'
      }
    }, {
      title: {
        text: 'Bütçe (TL)'
      },
      opposite: true
    }],
    plotOptions: {
      column: {
        grouping: false
      }
    },
    series: [{
      name: 'Proje Sayısı',
      data: [15, 12, 8, 7, 5],
      yAxis: 0,
      color: '#4285f4'
    }, {
      name: 'Toplam Bütçe',
      data: [1500000, 800000, 600000, 400000, 300000],
      yAxis: 1,
      color: '#34a853',
      type: 'spline'
    }]
  };

  const fakulteDetayVerileri = {
    enerji: {
      projeVerileri: {
        toplam: 52,
        dagilim: [
          { name: 'TÜBİTAK', y: 7, color: '#4285f4' },
          { name: 'AB', y: 4, color: '#34a853' },
          { name: 'BAP', y: 39, color: '#fbbc05' },
          { name: 'Döner Sermaye', y: 1, color: '#ea4335' },
          { name: '1773TTO', y: 1, color: '#673ab7' }
        ]
      },
      butceVerileri: {
        toplam: 19959997.97,
        dagilim: [
          { name: 'TÜBİTAK', y: 8500000, color: '#4285f4' },
          { name: 'AB', y: 4200000, color: '#34a853' },
          { name: 'BAP', y: 5200000, color: '#fbbc05' },
          { name: 'Döner Sermaye', y: 1200000, color: '#ea4335' },
          { name: '1773TTO', y: 859997.97, color: '#673ab7' }
        ]
      }
    },
    avrasya: {
      projeVerileri: {
        toplam: 56,
        dagilim: [
          { name: 'TÜBİTAK', y: 11, color: '#4285f4' },
          { name: 'AB', y: 2, color: '#34a853' },
          { name: 'BAP', y: 41, color: '#fbbc05' },
          { name: 'TTO', y: 1, color: '#ea4335' },
          { name: '1773TTO', y: 1, color: '#673ab7' }
        ]
      },
      butceVerileri: {
        toplam: 52508306.06,
        dagilim: [
          { name: 'TÜBİTAK', y: 41471700.00, color: '#4285f4' },
          { name: 'AB', y: 2120000.00, color: '#34a853' },
          { name: 'BAP', y: 5120551.01, color: '#fbbc05' },
          { name: 'TTO', y: 2537623.05, color: '#ea4335' },
          { name: '1773TTO', y: 1258432.00, color: '#673ab7' }
        ]
      }
    },
    bilisim: {
      projeVerileri: {
        toplam: 22,
        dagilim: [
          { name: 'TÜBİTAK', y: 5, color: '#4285f4' },
          { name: 'AB', y: 2, color: '#34a853' },
          { name: 'BAP', y: 13, color: '#fbbc05' },
          { name: 'TTO', y: 1, color: '#ea4335' },
          { name: '1773TTO', y: 1, color: '#673ab7' }
        ]
      },
      butceVerileri: {
        toplam: 12604898.15,
        dagilim: [
          { name: 'TÜBİTAK', y: 5500000, color: '#4285f4' },
          { name: 'AB', y: 2100000, color: '#34a853' },
          { name: 'BAP', y: 3500000, color: '#fbbc05' },
          { name: 'TTO', y: 1000000, color: '#ea4335' },
          { name: '1773TTO', y: 504898.15, color: '#673ab7' }
        ]
      }
    }
  };

  const getProjeGrafikOptions = (fakulteData) => {
    if (!fakulteData) return null;

    return {
      ...baseOptions,
      chart: {
        type: 'pie',
        height: 400
      },
      title: {
        text: `Toplam Yürüyen Proje Sayısı: ${fakulteData.projeVerileri.toplam}`,
        align: 'left',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.y}',
            style: {
              fontSize: '11px'
            }
          },
          showInLegend: true
        }
      },
      tooltip: {
        formatter: function() {
          return '<b>' + this.point.name + '</b><br/>' +
                 'Proje Sayısı: ' + this.point.y;
        }
      },
      series: [{
        name: 'Proje Sayısı',
        data: fakulteData.projeVerileri.dagilim
      }]
    };
  };

  const getButceGrafikOptions = (fakulteData) => {
    if (!fakulteData) return null;

    return {
      ...baseOptions,
      chart: {
        type: 'pie',
        height: 400
      },
      title: {
        text: `Toplam Yürüyen Bütçe Miktarı: ${fakulteData.butceVerileri.toplam.toLocaleString('tr-TR')} ₺`,
        align: 'left',
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f} ₺',
            style: {
              fontSize: '11px'
            }
          },
          showInLegend: true
        }
      },
      tooltip: {
        formatter: function() {
          return '<b>' + this.point.name + '</b><br/>' +
                 'Bütçe: ' + this.point.y.toLocaleString('tr-TR') + ' ₺';
        }
      },
      series: [{
        name: 'Bütçe Dağılımı',
        data: fakulteData.butceVerileri.dagilim
      }]
    };
  };

  const downloadButtonStyle = {
    backgroundColor: '#f1f1f1',
    border: 'none',
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  };

  const renderFilters = () => (
    <FilterCard title="" className={styles.filterCard}>
      <FilterCard.Row className={styles.filterRow}>
        <FilterCard.Col className={`${styles.filterCol} text-end`}>
          <button 
            className="btn btn-primary"
            onClick={() => setShowBudgetModal(true)}
          >
            <i className="fas fa-chart-bar me-2"></i>
            Fakültelere Göre Bütçe Grafikleri
          </button>
        </FilterCard.Col>
      </FilterCard.Row>
      
      <FilterCard.Row className={styles.filterRow}>
        <FilterCard.Col className={styles.filterCol}>
          <FilterCard.FormGroup label="Yıl Aralığı">
            <Select
              options={yearRangeOptions}
              value={yearRange}
              onChange={handleYearRangeChange}
              placeholder="Yıl aralığı seçin..."
            />
          </FilterCard.FormGroup>
        </FilterCard.Col>
        <FilterCard.Col className={styles.filterCol}>
          <FilterCard.FormGroup label="Fakülte">
            <Select
              options={facultyOptions}
              value={selectedFaculty}
              onChange={handleFacultyChange}
              placeholder="Fakülte seçin..."
            />
          </FilterCard.FormGroup>
        </FilterCard.Col>
      </FilterCard.Row>
    </FilterCard>
  );

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    let years = [];
    
    switch(yearRange[0]?.value) {
      case 'last3':
        years = Array.from({length: 3}, (_, i) => String(currentYear - i));
        break;
      case 'last10':
        years = Array.from({length: 10}, (_, i) => String(currentYear - i));
        break;
      case 'all':
        years = Array.from({length: 15}, (_, i) => String(currentYear - i));
        break;
      case 'last5':
      default:
        years = Array.from({length: 5}, (_, i) => String(currentYear - i));
    }
    
    setDisplayYears(years);
    
  }, [yearRange]);

  const getYillikTrendOptions = () => ({
    ...baseOptions,
    chart: {
      type: 'area',
      height: 350
    },
    title: {
      text: null
    },
    xAxis: {
      categories: [...displayYears].reverse(),
      tickmarkPlacement: 'on'
    },
    yAxis: {
      title: {
        text: 'Sayı'
      }
    },
    plotOptions: { 
      area: {
        stacking: 'normal',
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    series: [{
      name: 'Yayınlar',
      data: displayYears.map((_, index) => Math.floor(120 + (index * 20))),
      color: '#4285f4'
    }, {
      name: 'Projeler',
      data: displayYears.map((_, index) => Math.floor(45 + (index * 10))),
      color: '#34a853'
    }]
  });

  return (
    <div className="wrapper">
      <PageHeader 
        title="Grafikler"
        description="Akademik yayın performansı ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Grafikler' },
        ]}
      />

      {renderFilters()}

      <div className="row g-4">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-muted mb-0">Yıllık Trend</h6>
                <button 
                  style={downloadButtonStyle}
                  onClick={() => downloadAsPNG(chartRefs.yillikTrend, 'yillikTrend')}
                >
                  <i className="fas fa-download"></i>
                  İndir
                </button>
              </div>
              <HighchartsReact 
                highcharts={Highcharts} 
                options={getYillikTrendOptions()}
                ref={chartRefs.yillikTrend}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-muted mb-0">Fakülte Bazlı Dağılım</h6>
                <button 
                  style={downloadButtonStyle}
                  onClick={() => downloadAsPNG(chartRefs.fakulteDagilim, 'fakulteDagilim')}
                >
                  <i className="fas fa-download"></i>
                  İndir
                </button>
              </div>
              <HighchartsReact 
                highcharts={Highcharts} 
                options={fakulteDagilimOptions}
                ref={chartRefs.fakulteDagilim}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-muted mb-0">Proje Bütçe Dağılımı</h6>
                <button 
                  style={downloadButtonStyle}
                  onClick={() => downloadAsPNG(chartRefs.butceDagilim, 'butceDagilim')}
                >
                  <i className="fas fa-download"></i>
                  İndir
                </button>
              </div>
              <HighchartsReact 
                highcharts={Highcharts} 
                options={butceDagilimOptions}
                ref={chartRefs.butceDagilim}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-muted mb-0">Atıf Analizi</h6>
                <button 
                  style={downloadButtonStyle}
                  onClick={() => downloadAsPNG(chartRefs.atifAnalizi, 'atifAnalizi')}
                >
                  <i className="fas fa-download"></i>
                  İndir
                </button>
              </div>
              <HighchartsReact 
                highcharts={Highcharts} 
                options={atifAnaliziOptions}
                ref={chartRefs.atifAnalizi}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-muted mb-0">Proje Sayı-Bütçe Dağılımı</h6>
                <button 
                  style={downloadButtonStyle}
                  onClick={() => downloadAsPNG(chartRefs.projeSayiButce, 'projeSayiButce')}
                >
                  <i className="fas fa-download"></i>
                  İndir
                </button>
              </div>
              <HighchartsReact 
                highcharts={Highcharts} 
                options={projeSayiButceOptions}
                ref={chartRefs.projeSayiButce}
              />
            </div>
          </div>
        </div>
      </div>

      {showBudgetModal && (
        <div className="modal fade show" style={{display: 'block', zIndex: 1050}} tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Fakültelere Göre Bütçe Grafikleri</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowBudgetModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-4" style={{zIndex: 10000, position: 'relative'}}>
                  <div className="col-md-6">
                    <FilterCard.FormGroup label="Yıl">
                      <Select
                        options={yearOptions}
                        value={modalSelectedYear}
                        onChange={handleModalYearChange}
                        placeholder="Yıl seçin..."
                        isClearable={false}
                        menuPortalTarget={document.body}
                      />
                    </FilterCard.FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FilterCard.FormGroup label="Fakülte">
                      <Select
                        options={facultyOptions}
                        value={modalSelectedFaculty}
                        onChange={handleModalFacultyChange}
                        placeholder="Fakülte seçin..."
                        isClearable={false}
                        menuPortalTarget={document.body}
                      />
                    </FilterCard.FormGroup>
                  </div>
                </div>
                {modalSelectedFaculty[0]?.value !== 'all' ? (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="text-muted mb-0">Proje Sayısı Dağılımı</h6>
                            <button 
                              style={downloadButtonStyle}
                              onClick={() => downloadAsPNG(chartRefs.modalProje, `${modalSelectedFaculty[0]?.value}_proje_dagilim`)}
                            >
                              <i className="fas fa-download"></i>
                              İndir
                            </button>
                          </div>
                          {fakulteDetayVerileri[modalSelectedFaculty[0]?.value] && (
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getProjeGrafikOptions(fakulteDetayVerileri[modalSelectedFaculty[0]?.value])}
                              ref={chartRefs.modalProje}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="text-muted mb-0">Bütçe Dağılımı</h6>
                            <button 
                              style={downloadButtonStyle}
                              onClick={() => downloadAsPNG(chartRefs.modalButce, `${modalSelectedFaculty[0]?.value}_butce_dagilim`)}
                            >
                              <i className="fas fa-download"></i>
                              İndir
                            </button>
                          </div>
                          {fakulteDetayVerileri[modalSelectedFaculty[0]?.value] && (
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getButceGrafikOptions(fakulteDetayVerileri[modalSelectedFaculty[0]?.value])}
                              ref={chartRefs.modalButce}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="text-muted mb-0">Fakültelere Göre Bütçe Dağılımı</h6>
                        <button 
                          style={downloadButtonStyle}
                          onClick={() => downloadAsPNG(chartRefs.modalGenel, 'fakulteler_butce_dagilim')}
                        >
                          <i className="fas fa-download"></i>
                          İndir
                        </button>
                      </div>
                      <HighchartsReact 
                        highcharts={Highcharts} 
                        options={fakulteButceOptions}
                        ref={chartRefs.modalGenel}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showBudgetModal && (
        <div className="modal-backdrop fade show" style={{zIndex: 1040}}></div>
      )}
    </div>
  );
};

export default Grafikler; 